class CartAddedDrawer extends HTMLElement {
  constructor () {
    super();

    this.drawerElement = null;
    this.handleItemAdded = this.handleItemAdded.bind( this );
  }

  connectedCallback () {
    this.drawerElement = this.closest( 'slide-drawer' );

    this.cartUrl = this.dataset.cartUrl || window.Shopify?.routes?.cart_url || '/cart';
    this.currency = this.dataset.currency || window.Shopify?.currency?.active || 'GBP';

    this.contentWrapper = this.querySelector( '[data-cart-drawer-content]' );
    this.emptyState = this.querySelector( '[data-cart-drawer-empty]' );
    this.imageWrapper = this.querySelector( '[data-cart-drawer-image]' );
    this.titleElement = this.querySelector( '[data-cart-drawer-title]' );
    this.priceElement = this.querySelector( '[data-cart-drawer-price]' );
    this.optionsElement = this.querySelector( '[data-cart-drawer-options]' );
    this.viewBagButton = this.querySelector( '[data-cart-drawer-view-bag]' );

    this.ar_width = window.productCard.aspectRatio.width || 459;
    this.ar_height = window.productCard.aspectRatio.height || 674;

    window.addEventListener( 'cart:item-added', this.handleItemAdded );
  }

  disconnectedCallback () {
    window.removeEventListener( 'cart:item-added', this.handleItemAdded );
  }

  handleItemAdded ( event ) {
    const detail = event.detail || {};
    const { lineItem, cart, compareAtPrice } = detail;

    if ( !lineItem ) {
      return;
    }

    this.renderItem( lineItem, cart, compareAtPrice );
    this.toggleContent( true );

    if ( this.viewBagButton ) {
      const baseLabel = this.viewBagButton.dataset.baseLabel || this.viewBagButton.textContent.trim();
      if ( cart?.item_count !== undefined ) {
        this.viewBagButton.textContent = `${baseLabel} (${cart.item_count})`;
      }
    }

    if ( this.drawerElement ) {
      this.drawerElement.open();
    }
  }

  renderItem ( item, cart, compareAtPrice ) {
    if ( !item ) return;

    const itemImage = item.image || item.featured_image?.url;
    if ( this.imageWrapper ) {
      const img_width = 160;
      const img_height = Math.round(img_width * this.ar_height / this.ar_width)

      this.imageWrapper.innerHTML = itemImage
        ? `<img src="${itemImage}&crop=center&width=${img_width}&height=${img_height}" alt="${item.title || ''}" class="block w-full h-full object-cover" loading="eager" />`
        : `<div class="h-full w-full bg-neutral-200" style="width: ${img_width}px; height: ${img_height}px;"></div>`;
    }

    if ( this.titleElement ) {
      const rawTitle = item.product_title || item.title || '';
      if (rawTitle.includes(' - ')) {
        const parts = rawTitle.split(' - ');
        const first = parts[0].trim();
        const last = parts[parts.length - 1].trim();

        this.titleElement.textContent = first;

        if (Array.isArray(item.options_with_values)) {
          item.options_with_values.unshift({ name: 'Colour', value: last });
        } else {
          item.options_with_values = [{ name: 'Colour', value: last }];
        }
      } else {
        this.titleElement.textContent = rawTitle;
      }
    }

    if ( this.priceElement ) {
      const unitPrice = item.final_price ?? item.price;
      const comparePrice = Number( compareAtPrice );

      this.priceElement.replaceChildren();

      if ( comparePrice > unitPrice ) {
        const comparePriceElement = document.createElement( 's' );
        comparePriceElement.className = 'line-through text-gray-500';
        comparePriceElement.textContent = this.formatMoney( comparePrice );
        this.priceElement.append( comparePriceElement, document.createTextNode( ' ' ) );
      }

      const currentPriceElement = document.createElement( 'span' );
      currentPriceElement.textContent = this.formatMoney( unitPrice );
      this.priceElement.append( currentPriceElement );
    }

    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.push({ name: 'Qtn', value: item.quantity });
    } else {
      item.options_with_values = [{ name: 'Qtn', value: item.quantity }];
    }

    if ( this.optionsElement ) {
      let options = Array.isArray( item.options_with_values )
        ? item.options_with_values.map( ( option ) => {
          return `<div>${option.name}</div><div class="font-normal">${option.value}</div>`;
        } ).join( '' )
        : '';

      this.optionsElement.innerHTML = options;
    }
  }

  toggleContent ( hasItem ) {
    if ( this.contentWrapper ) {
      this.contentWrapper.hidden = !hasItem;
    }
    if ( this.emptyState ) {
      this.emptyState.hidden = hasItem;
    }
  }

  formatMoney ( cents ) {
    if ( typeof cents === 'string' ) {
      cents = cents.replace( '.', '' );
    }

    const value = parseInt( cents, 10 );
    if ( Number.isNaN( value ) ) return '0';

    const amount = ( value / 100 ).toFixed( 2 );

    switch ( this.currency ) {
      case 'GBP':
        return `£${amount}`;
      case 'EUR':
        return `€${amount}`;
      case 'JPY':
        return `¥${Math.round( value / 100 )}`;
      case 'USD':
      default:
        return `$${amount}`;
    }
  }

}

customElements.define( 'cart-added-drawer', CartAddedDrawer );
